<div class="row" *ngIf="showDialog" [dir]="this.app.getUserDire()">
    <div class="d-flex justify-content-between px-3">
        <div class="row align-items-center">
            <p class="m-0 p-0 px-2 likesNum">
                <span class="d-flex align-items-center">
                    <mat-icon class="favColor">favorite</mat-icon>
                </span>
                <span class="mx-1">
                    {{Likes?.length ? Likes?.length : 0}}
                </span>
            </p>
        </div>
        <div>
            <p class="LikesP m-0 p-0 pt-2">{{ 'social.likes' | translate }}</p>
        </div>
        <div>
            <mat-icon (click)="cancel()" class="cancelBtn pointer">cancel</mat-icon>
        </div>
    </div>

    <hr class="grey m-0 my-3">
    <!-- view Section -->
    <div class="overFlowH" *ngIf="Likes?.length > 0">
        <div class="mb-3" *ngFor="let view of Likes; let i = index">
            <div class="d-flex justify-content-start">
                <div class="d-flex align-items-center">
                    <img class="border-less-comments object-cover" [src]="app.getUserImage(view?.createdByPicture)"
                        alt="User Image">
                    <div class="mx-2 d-flex align-items-start">
                        <div>
                            <p class="m-0 CommentatorName">{{view?.createdByName}}</p>
                            <p class="m-0 posterSpech">{{view?.speciality}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- view Section -->
</div>